// extracted by mini-css-extract-plugin
module.exports = {"content":"content--MTjQO","stage":"stage--jvsDa","pickContainer":"pickContainer--zJz0G","picks":"picks--hPUo-","mistake":"mistake--kNuKh","correct":"correct--bkREJ"};